import { render } from "./HistogramChart.vue?vue&type=template&id=0acb3cba&ts=true"
import script from "./HistogramChart.vue?vue&type=script&lang=ts"
export * from "./HistogramChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__